import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { LoadingContainer, NoData, SectionWrapper } from './ChartList.styles';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { useDiversedSuppliersContext } from 'contexts/SupplierDiversity/DiversedSuppliersProvider';
import Header from 'SupplierDiversity/components/Header/Header';

const chartTitle =
	'Total Client Suppliers Vs Total Diversity Suppliers by Category';

const DiversedSuppliers = () => {
	const { isLoading, data, options } = useDiversedSuppliersContext();
	return (
		<SectionWrapper>
			<Header chartTitle={chartTitle} />
			{isLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact highcharts={Highcharts} options={options} />
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default DiversedSuppliers;
